<template>

    <div v-loading="loading">
        <div class="card card-custom card-stretch gutter-b">
            <div class="card-header">
                <div class="card-title">
                    <span class="card-icon">
                        <i class="flaticon2-delivery-package text-primary"></i>
                    </span>
                    <h3 class="card-label"><b class="title-header">{{BusinessTitle}}</b></h3>
                </div>
            </div>
            <div class="card-body">
                <el-form :model="dynamicValidateForm" ref="ruleForm" class="demo-dynamic">
                    <div>
                        <table id="uniquetable" class="table rounded table-top" style="width: 100%;">
                            <thead class="thead-dark text-center">
                            <tr>
                                <th style="width: 40%">費目カテゴリ</th>
                                <th style="width: 50%">備考</th>
                                <th style="width: 10%"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(data, index) in dynamicValidateForm.listCate">
                                <td style="width: 40%">
                                    <el-form-item :key="data.key" :prop="'listCate.'+index+`.name`">
                                        <el-input v-model="data.name" :maxlength="maxLengthName" :key="index">
                                        </el-input>
                                    </el-form-item>
                                </td>
                                <td style="width: 50%">
                                    <el-form-item :key="data.key" :prop="'listCate.'+index+`.remark`">
                                        <el-input v-model="data.remark" :maxlength="maxLengthRemark"
                                                  :key="index">
                                        </el-input>
                                    </el-form-item>
                                </td>
                                <td class="text-center" style="width: 10%">
                                    <el-button class="delete-btn" type="danger" icon="el-icon-delete" circle @click="openPopup(data.category_id, index)"></el-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <el-form-item>
                        <div class="mt-8">
                            <el-button type="primary" @click="addLine">行追加</el-button>
                        </div>
                        <div class="text-center mb-12">
                            <el-button type="primary" @click="submitForm">確定</el-button>
                        </div>
                    </el-form-item>
                    <input type="hidden" name="_csrf" v-model="dynamicValidateForm._csrf" />
                </el-form>
            </div>
        </div>
        <Popup :id="popupId" :content="popupMessage">
            <b-button
                class="btn-primary"
                @click="deleteReEntrustment()"
            >
                はい
            </b-button>
            <b-button
                class="btn-primary"
                @click="$bvModal.hide(popupId)"
            >
                いいえ
            </b-button>
        </Popup>
    </div>
</template>

<script>

import { GET_LIST_COST } from "@/core/services/store/businessCost.module";
import { mapActions, mapGetters } from "vuex";
import apiService from "@/core/services/api.service";
import Popup from '@/view/components/Popup'
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import { SUCCESS_MESSAGE, DELETE_MESSAGE } from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
    components: {
        Popup
    },
    data() {
        return {
            dynamicValidateForm: {
                listCate: [{
                    category_id: '',
                    name: '',
                    remark: ''
                }],
                _csrf:''
            },
            popupId: 'updateCostPopup',
            popupMessage: DELETE_MESSAGE,
            selectedDeleteId: null,
            selectedDeleteIndex: null,
            isSubmit: false,
            loading: false,
            options: [],
            maxLengthRemark: 64,
            maxLengthName: 32
        };
    },

    computed: {
        ...mapGetters(["getListCost", "getSuccessful", "BusinessTitle"]),
    },

    async created() {
        await this.getListCate();
        this.dynamicValidateForm._csrf = getCsrfRandom()
    },


    methods: {
        ...mapActions([GET_LIST_COST, SET_TITLE_BUSINESS]),
        async addLine() {
            await this.dynamicValidateForm.listCate.push({
                category_id: '',
                name: '',
                remark: ''
            });

            const table = document.getElementById('uniquetable')
            const lastRow = table.rows[table.rows.length-1]
            lastRow.scrollIntoView({block: "start", behavior: "smooth"})
        },
        async submitForm() {
            this.isSubmit = true
            this.$refs["ruleForm"].clearValidate()
            this.loading = true
            await apiService.post(`category/add`, this.dynamicValidateForm).then(data => {
                if (data && data.data && data.data.success) {
                    this.getListCate();
                    this.notifySuccess(SUCCESS_MESSAGE)
                    // this.restForm()
                } else {
                    if (data.data.code == 422) {
                        this.showErrorMessage(data.data.data, 'ruleForm')

                    } else if (data.data.code == 400) {
                        this.notifyError(data.data.message)
                    } else {
                        this.notifyError('error server')
                    }
                }
                this.loading = false
            }).catch(e => {
                this.loading = false
                this.notifyError(e)
            })
            this.isSubmit = false

        },
        // restForm() {
        //     this.dynamicValidateForm = {
        //         listCate: [
        //             {
        //                 category_id: '',
        //                 name: '',
        //                 remark: ''
        //             }
        //         ],
        //         himoku_id: ''
        //     }
        // },
        async getListCate() {
            this.loading = true
             // this.turnOffErrorMessage('ruleForm')
            const response = await apiService.get(`category/list`)
            this.loading = false
            if (response.data.code == 200) {
                this.dynamicValidateForm.listCate = response.data.data
                
            }
            if (response.data.code == 400) {
                this.notifyError(response.data.message)
            }
        },
        openPopup(id, index) {
            this.selectedDeleteId = id
            this.selectedDeleteIndex = index
            this.$bvModal.show(this.popupId)
        },
        async deleteReEntrustment() {
            this.$bvModal.hide(this.popupId)
            if (!this.selectedDeleteId) {
                this.dynamicValidateForm.listCate.splice(this.selectedDeleteIndex, 1)
            } else {
                try {
                    this.loading = true
                    const response = await apiService.post(`category/delete/${this.selectedDeleteId}`)
                    if (response.data.code == 200) {
                        this.notifySuccess(SUCCESS_MESSAGE)
                    }
                    if (response.data.code == 400) {
                        this.notifyError("Selected Re-Entrustment is not exist")
                    }
                    if (response.data.code == 405) {
                        this.notifyError(response.data.message)
                    }

                    await this.getListCate()
                    this.loading = false
                } catch (e) {
                    this.loading = false
                    this.notifyError(e)
                }
            }
        }
    }
}
</script>
<style scoped>
.title-form {
    color: #ffffff;
    background-color: #181C32;
    font-weight: 600;
    font-size: 1rem;
    border-bottom-width: 1px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    border: 1px solid #EBEDF3;
    border-collapse: collapse;
}

.input-select {
    width: 60%;
}

.title-select {
    font-weight: 600;
    font-size: 1rem;
}

.input-form-name {
    padding: 0.5rem;
}

.table-top,.table-top th,.table-top td {
    border: 1px solid #EBEDF3;
    border-collapse: collapse;
}
#uniquetable thead {
    display: block;
    width: 100%;
}

#uniquetable tbody {
    display: block;
    width: 100%;
    max-height: 350px;
    overflow-y: overlay;
    overflow-x: hidden;
}

#uniquetable tbody tr,
#uniquetable thead tr {
    width: 100%;
    display: table;
}

#uniquetable tbody tr td,
#uniquetable thead tr th {
    display: table-cell;
    width: 30%;
    min-height: 75px;
}
</style>
